import ajax from './index'
import apiEnv from './apiEnv'



//已收款项列表
export function receivedList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/fundYet/list`,data)
}
//发票管理列表
export function invoiceManageList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/list`,data)
}
//发票管理列表-角标
export function invoiceManageCount(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/count`,data)
}
//应付账款列表
export function paymentList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/payment/list `,data)
}
//付款管理列表--角标
export function paymentManageCount(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/paymentManage/count`,data)
}
//付款管理列表
export function paymentManageList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/paymentManage/list`,data)
}
//项目款项-列表
export function projectFundsList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/projectFunds/list`,data)
}
//应收账款列表
export function receivableList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/receivable/list`,data)
}
//发票|付款管理列表-详情
export function invoiceManagedetail(data) {
    //java的
    // return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/detail`,data)

    //发票|付款管理列表-详情  .net的
    return ajax.post(`${apiEnv.api4}/api/Receivable/GetManagerInvoiceDetail`,data)
}
 
//发票|付款管理列表-详情 ava的
export function invoiceManagedetail_java(data) {
    //java的
      return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/detail`,data)
}
 


//发票管理列表-详情/确认开票
export function confirmInvoiceApi(data) {
  // return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/detail/confirmInvoice`,data) 

    //改为.net的接口
    return ajax.post(`${apiEnv.api4}/api/Receivable/ConfirmInvoiceStatus`,data)
}
//发票管理列表-详情/确认回款
export function returnPayments(data) {
    // return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/detail/returnPayments`,data)
    //改为。net的
    return ajax.post(`${apiEnv.api4}/api/Receivable/ConfirmReturnMoney`,data)
}
//拒绝开票(应收账款)
export function refuseInvoice(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/receivable/refuseInvoice`,data)
}
//付款管理列表/拒绝收票
export function refuseTicket(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/paymentManage/refuseTicket`,data)
}
//付款管理列表/确认支付
export function confirmPayment(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/paymentManage/confirmPayment`,data)
}
//付款管理列表/批量收票
export function batchTicket(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/paymentManage/batchTicket`,data)
}
//应收账款-批量开票(回显)
export function batchInvoiceEcho(data) {
    // return ajax.post(`${apiEnv.api2}/gz/admin/finance/receivable/batchInvoiceEcho`,data)
    return ajax.post(`${apiEnv.api4}/api/Receivable/ApplyInvoiceData`,data)
}
//应收账款-确认开票
export function confirmInvoice(data) {
    // return ajax.post(`${apiEnv.api2}/gz/admin/finance/receivable/confirmInvoice`,data)

    return ajax.post(`${apiEnv.api4}/api/Receivable/ConfirmInvoice`,data)
}
//平台服务利润-列表
export function ordSouSerProfitList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/ordSouSerProfit/list`,data)
}
//项目服务利润-列表
export function proSerProfitList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/finance/proSerProfit/list`,data)
}

//角色下拉
export function roleOption(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/role`,data)
}
//服务来源下拉
export function orderSourceOption() {
    return ajax.post(`${apiEnv.api2}/crm/option/orderSource`)
}
//款项名称下拉
export function payMentNameOption() {
    return ajax.post(`${apiEnv.api2}/crm/option/payMentName`)
}
//开票选项下拉
export function invoiceContentOption() {
    return ajax.post(`${apiEnv.api2}/crm/option/invoiceContent`)
}
//税点下拉
export function taxPointOption() {
    return ajax.post(`${apiEnv.api2}/crm/option/taxPoint`)
}

// 拒绝开票（发票管理）
export function refuseInvoiceReject(data) {
    //return ajax.post(`${apiEnv.api2}/gz/admin/finance/invoiceManage/detail/refuseInvoice`,data)

    return ajax.post(`${apiEnv.api4}/api/Receivable/DenyInvoice`,data)
}



// 获取提现列表
export function GetWithdrawList(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/GetWithdrawList`,data)
}
// 提现确认付款
export function WithdrawApplyConfirmPay(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/WithdrawApplyConfirmPay`,data)
}
// 提现拒绝付款
export function WithdrawApplyReject(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/WithdrawApplyReject`,data)
}
// 同步数据
export function SyncGqData(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/SyncGqData`,data)
}
// 推送数据
export function MakePushGqFlag(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/MakePushGqFlag`,data)
}
// 提交当前结算单
export function SubmitSettleBill(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/SubmitSettleBill`,data)
}
//发票管理列表-详情/作废电子发票
export function DisableEInvoice(data) {
    return ajax.post(`${apiEnv.api4}/api/Receivable/DisableEInvoice`,data)
}
//发票管理列表-详情/重开电子发票
export function ReInvoiceSubmit(data) {
    return ajax.post(`${apiEnv.api4}/api/Receivable/ReInvoiceSubmit`,data)
}
//线下发票管理列表
export function GetOfflineInvoiceCount(data) {
    return ajax.post(`${apiEnv.api4}/api/OfflineInvoice/GetOfflineInvoiceCount`,data)
}
//线下发票管理列表
export function GetOfflineInvoiceList(data) {
    return ajax.post(`${apiEnv.api4}/api/OfflineInvoice/GetOfflineInvoiceList`,data)
}
//获取线下发票
export function GetOfflineInvoiceDetails(data) {
    var url=`${apiEnv.api4}/api/OfflineInvoice/GetOfflineInvoiceDetails`;
    return ajax.get(url,data)
}
//线下发票,确认回款
export function OfflineInvoiceConfirmReturnMoney(data) {
    var url=`${apiEnv.api4}/api/OfflineInvoice/OfflineInvoiceConfirmReturnMoney`;
    return ajax.post(url,data)
}
// 财务提现回款列表
export function GetCommissionApplyList(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/GetCommissionApplyList`,data)
}
// 财务提现回款导出
export function ExportCommissionApply(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/ExportCommissionApply`,data)
}
// 财务提现-有垫资申请-查看
export function GetJobAdvanceFundsInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/WithdrawApply/GetJobAdvanceFundsInfo`,data)
}
// 获取发票详细回款列表
export function GetInvoiceJobInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/Receivable/GetInvoiceJobInfo`,data)
}